<!-- 
DieCare.vue
功能：身故關懷名單
作者：i9400538 陳博承
完成：2021-12-02
-->
<template>
  <div>
    <div class="container-fluid" style="overflow: hidden;">
      <div
        class="mb-3"
        :class="{'section-loading': infoLoading}"
        style="overflow: hidden;max-height: 140px;"
      >
        <div class="float-left w-75">
          <h4 class="mb-line text-green mt-0 mb-0">
            {{ categoryInfo.subcategory }}-{{ categoryInfo.category_name }}
            <a
              v-if="categoryInfo.upload_file"
              class="text-orange"
              style="text-decoration:none;"
            >
              <i style="cursor:pointer;" class="icon-attach ml-2" @click="download()"></i>點我
            </a>
          </h4>
          <div class="mb-line" style>
            <span
              class="font-weight-bold mr-2"
            >{{ categoryInfo.upload_date | dateFormat }} ~ {{ categoryInfo.end_date | dateFormat }}</span>
          </div>
          <div class="mb-line w-75">
            <span class="font-weight-bold mr-2">{{ categoryInfo.description }}</span>
          </div>
        </div>
        <div class="float-left w-25">
          <div class="mb-line">
            <span class="font-weight-bold mr-2">維護單位</span>
            <span>{{ categoryInfo.dev_name }}</span>
          </div>
          <div class>
            <span class="font-weight-bold mr-2">聯絡電話</span>
            <span>{{ categoryInfo.contact }}</span>
          </div>
          <div class="mb-line">
            <span class="font-weight-bold mr-2">聯絡分機</span>
            <span>{{ categoryInfo.contact_tel }}</span>
          </div>
          <div :class="{'section-loading': isLoading_btn}">
            <a class="btn btn-default m-0" @click="satisfactionModal" v-if="isBtnEnble">滿意度調查</a>
            <a class="btn btn-default m-0" @click="alreadyDone" disabled="disabled" v-else>滿意度調查</a>
            &nbsp;&nbsp;
            <button
              type="button"
              style="height:43px;"
              @click="backToIndex"
              class="position-absolute btn btn-default m-0"
              v-html="'<span style=\'font-size:1rem\'>回上一頁<span>'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="container-fluid" :class="{'section-loading': isLoading}">
      <div class="row">
        <die-care-data-table
          :height="data_table_height"
          @update="updateSelection"
          @scheduled-access="ScheduledAccess"
          @die-check-open="DieCheckOpen"
          :table-data="tableData"
          :categoryInfo="categoryInfo"
          :linkUrl="linkUrl"
        />
      </div>
    </div>
    <!--開啟連結用表單-->
    <div>
      <form v-show="false" name="form_A" :action="linkUrl" method="post" target="_blank">
        <input name="USER_ID" :value="linkID" type="hidden" />
        <input name="CLC_NO" :value="linkClcNo" type="hidden" />
        <button type="submit" id="sendSubmit"></button>
      </form>
    </div>

    <section class="container-fluid fixed-bottom">
      <div class="row">
        <div class="col-12"></div>
        <div class="col-9 col-sm-8 col-md-8"></div>
        <div class="col-3 col-sm-4 col-md-4 text-right">
          <button
            class="btn btn-primary"
            @click="panelOpen('groupModalOpen')"
            :disabled="!selection.length"
          >加入群組</button>
          <button
            class="btn btn-primary mr-0"
            @click="panelOpen('printModalOpen')"
            :disabled="!selection.length"
          >列印名條</button>
        </div>
      </div>
    </section>

    <!-- 列印名條 -->
    <print-modal :open="printModalOpen" :custs="selection" @close="panelClose('printModalOpen')" />

    <!-- 加入群組 -->
    <group-modal
      :open="groupModalOpen"
      :custs="selection"
      @submit="submitGroup"
      @close="panelClose('groupModalOpen')"
    />

    <!-- 滿意度調查 -->
    <satisfaction-modal
      :open="satisfactionModalOpen"
      @report="report"
      @close="panelClose('satisfactionModalOpen')"
    />

    <!-- 排訪 -->
    <scheduled-access
      :open="ScheduledAccessModalOpen"
      :record="currentRecord"
      :cat-info="categoryInfo"
      @close="panelClose('ScheduledAccessModalOpen')"
      @submit="submitScheduledAccess"
    />

    <!-- 身故確認視窗 -->
    <die-check-modal
      :open="DieCheckModalOpen"
      :cust="cust"
      :action="action"
      @close="panelClose('DieCheckModalOpen')"
      @submit="submitDieCheck"
      @accept="acceptReplyCause"
      @query="doQuery"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import PrintModal from "@/desktop/components/PrintModal";
import GroupModal from "@/desktop/components/GroupModal";
import DieCheckModal from "@/desktop/components/DieCheckModal";
import DieCareDataTable from "@/desktop/components/ListsArea/DataTable/DieCareDataTable";
import SatisfactionModal from "@/desktop/components/ListsArea/SatisfactionModal";
import ScheduledAccess from "@/desktop/components/ListsArea/ScheduledAccess";
//service
import {
  getDieCareList,
  doDieCheck,
  doReplyCauseCheck,
  getCategoryDetail,
  isSatisfactionSurveyFinish,
  queryBookedVisitEvent,
  downloadFile_m0
} from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "DieCare",
  mixins: [commonMixin],
  components: {
    DieCareDataTable,
    SatisfactionModal,
    PrintModal,
    GroupModal,
    DieCheckModal,
    ScheduledAccess
  },
  data() {
    //data block layout
    return {
      isLoading_btn: true,
      isLoading: false,
      infoLoading: false,
      isBtnEnble: true,
      categoryInfo: {},
      printModalOpen: false,
      groupModalOpen: false,
      tableData: [],
      selection: [],
      satisfactionModalOpen: false,
      data_table_height: 0,
      ScheduledAccessModalOpen: false,
      currentRecord: {},
      DieCheckModalOpen: false,
      cust: {}, //保戶資料
      action: "1",
      linkUrl: "",
      linkID: "",
      linkClcNo: ""
    };
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    updateSelection(val) {
      this.selection = val;
    },
    PrintModal() {
      this.panelOpen("printModalOpen");
    },
    satisfactionModal() {
      this.panelOpen("satisfactionModalOpen");
    },
    report() {
      this.$toast.info({ title: "滿意度調查 已回報" });
      this.isBtnEnble = false;
      this.panelClose("satisfactionModalOpen");
    },
    //回上一頁
    backToIndex() {
      this.$emit("change-status", "STATUS_SERVICE_RIGHT_LIST");
    },
    //加入群組導頁至 群組列表
    submitGroup(group) {
      this.panelClose("groupModalOpen");
      this.$router.push({
        path: `/group/1`,
        query: { grp_id: group.grp_id, grp_name: group.grp_name }
      });
    },
    //保戶身故狀況回報
    submitDieCheck(visit_reply, visit_way) {
      this.panelClose("DieCheckModalOpen");
      this.isLoading = true;
      doDieCheck(
        this.$store.state.userInfo.id,
        this.cust.id,
        this.cust.birthday,
        visit_reply,
        visit_way ? visit_way : "0",
        "1"
      ).then(result => {
        this.isLoading = false;
        if (result.header && result.header.status == "200") {
          if (result.body.flag && result.body.flag == "Y") {
            this.setToastMsg("身故確認成功");
            this.init();
          } else {
            this.setToastMsg("更新身故確認API發生異常，請稍後再試");
          }
        } else {
          this.setToastMsg(result.header.message);
        }
      });
    },
    //未辦理原因回報
    acceptReplyCause(reply_cause, reply_memo) {
      this.panelClose("DieCheckModalOpen");
      this.isLoading = true;
      doReplyCauseCheck(
        this.$store.state.userInfo.id,
        this.cust.id,
        this.cust.birthday,
        this.cust.clc_no,
        reply_cause,
        reply_memo
      ).then(result => {
        this.isLoading = false;
        if (result.header && result.header.status == "200") {
          if (result.body.flag && result.body.flag == "Y") {
            this.setToastMsg("回報未辦理原因成功");
            this.init();
          } else {
            this.setToastMsg("回報未辦理原因API發生異常，請稍後再試");
          }
        } else {
          this.setToastMsg(result.header.message);
        }
      });
    },
    //身故確認
    DieCheckOpen(cust, action) {
      this.cust = cust;
      this.action = action;
      this.panelOpen("DieCheckModalOpen");
    },
    //取得性別
    getGender(csid) {
      if (!csid || !csid.trim()) {
        return;
      }
      let id = csid.toUpperCase();
      let gender = "";
      if (id.match("1|8|A|C")) {
        gender = 1;
      } else if (id.match("2|9|B|D")) {
        gender = 2;
      }
      return gender;
    },
    init() {
      // 資料初始化
      this.checkIsSatisfactionSurveyFinish();
      this.isLoading = true;
      getDieCareList(this.$store.state.userInfo.id).then(result => {
        this.isLoading = false;
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.result
        ) {
          let connect = "";
          let CsidData = "";
          result.body.result.map(item => {
            connect = connect + "," + item.end_id;
          });
          if (connect.length > 0) {
            CsidData = connect.substr(1);
          }
          queryBookedVisitEvent(this.$store.state.userInfo.id, CsidData).then(
            visitData => {
              this.isLoading = false;
              if (visitData.header && visitData.header.status === "200") {
                let visitList = visitData.body.detail;
                this.tableData = result.body.result.map(item => {
                  let visit = { visit: {} };
                  visitList.forEach(vItem => {
                    if (vItem.csidno == item.end_id) {
                      visit.visit = vItem;
                    }
                  });

                  return {
                    id: item.end_id || "", //身故者ID
                    name: item.end_name || "", //身故者姓名
                    sex: this.getGender(item.end_id[1]) || "", //性別
                    birthday: item.end_brdy || "", //身故者生日
                    end_date: item.end_date || "", //身故日
                    insert_date: item.insert_date || "", //通報日期
                    insr_type: item.insr_type || "", //通報來源
                    visit_date: item.visit_date || "", //身故確認時間
                    visit_reply: item.visit_reply || "", //身故確認狀態
                    visit_way: item.visit_way || "", //未身故確認方式
                    reply_date: item.reply_date || "", //未辦理原因回報時間
                    reply_cause: item.reply_cause || "", //未辦理原因
                    reply_memo: item.reply_memo || "", //未辦理原因備註
                    clc_no: item.clc_no || "", //收費代號
                    clc_name: item.clc_name || "", //派件AG姓名
                    clc_id: item.clc_id || "", //派件AG ID
                    vip_level: item.vip_lvl, // 顯示VIP
                    is_visit: item.is_visit || false, //不可回報身故狀態
                    is_reply: item.is_reply || false, //不可回報未辦理原因
                    is_exist: item.is_exist || false, //判斷是否有客戶資料
                    ...visit // 寫入排訪資料
                  };
                });
              }
            }
          );
          this.registerHanlink(); // for hard word
        }
      });
      this.getTitleInfo();
    },
    getTitleInfo() {
      // 取得專區資訊
      this.infoLoading = true;
      getCategoryDetail(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        this.infoLoading = false;
        if (result.header && result.header.status == "200") {
          this.categoryInfo = result.body[0];
        }
      });
    },
    checkIsSatisfactionSurveyFinish() {
      // 檢查是否已回報過滿意度調查
      this.isLoading_btn = true;
      isSatisfactionSurveyFinish(
        this.$store.state.userInfo.id,
        this.$store.state.listAreaSerNo
      ).then(result => {
        if (result.header && result.header.status == "200") {
          this.isBtnEnble = result.body.isfinish == "0";
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message });
          } else {
            this.$toast.info({ title: "查詢滿意度調查失敗,請重新操作" });
          }
        }
        this.isLoading_btn = false;
      });
    },
    alreadyDone() {
      this.$toast.info({ title: "您已回報過滿意度調查,無法重複操作" });
    },
    ScheduledAccess(record) {
      this.currentRecord = record;
      this.panelOpen("ScheduledAccessModalOpen");
    },
    submitScheduledAccess() {
      this.panelClose("ScheduledAccessModalOpen");
      // 資料初始化
      this.init();
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若内嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          this.categoryInfo.upload_file,
          this.categoryInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.categoryInfo.ser_no,
          this.categoryInfo.upload_file
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, this.categoryInfo.upload_file);
          }
        });
      }
    },
    //待辦項目查詢
    doQuery() {
      //call api 寫入歷程檔
      doDieCheck(
        this.$store.state.userInfo.id,
        this.cust.id,
        this.cust.birthday,
        this.cust.visit_reply || "",
        this.cust.visit_way || "",
        "2"
      );
      this.linkID = this.cust.id; //user_id
      this.linkClcNo = this.cust.clc_no; //clc_no
      const submitForm = document.querySelector("#sendSubmit");
      setTimeout(() => {
        submitForm.click();
      }, 100);
    }
  },
  mounted() {
    // 資料初始化
    this.init();
    let href = window.location.href; // 設定動態 url
    let netzone = "https://twas3.";
    if (href.indexOf("tmycrm") !== -1) {
      netzone = "https://twas3.";
    } else if (href.indexOf("smycrm") !== -1) {
      netzone = "https://swas3.";
    } else if (href.indexOf("mycrm") !== -1) {
      netzone = "https://was2.";
    }
    this.linkUrl =
      netzone +
      "cathaylife.com.tw/AIWeb/servlet/HttpDispatcher/AIE2_0300/prompt?";

    this.data_table_height =
      parseInt($(window).height()) - $("tbody").offset().top - 80;
    let self = this;
    $(window).bind("resize", function(event) {
      self.data_table_height =
        parseInt($(window).height()) - $("tbody").offset().top - 80;
    });
    $(".tab-content").css("padding-bottom", "74px");
  }
};
</script>
